import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { once } from 'ramda';
import { NpsWidget as NpsWidgetComponent } from '@cian/nps-widget';

import { trackDecline, trackAccept, trackShow } from './tracking';

import * as styles from './styles.css';

export interface INpsWidgetProps {
  isAuthenticated?: boolean | null;
  href?: string;
  isEnabled?: boolean;
}

interface INpsWidgetState {
  visible: boolean;
}

export class NpsWidget extends React.Component<INpsWidgetProps, INpsWidgetState> {
  public state = {
    visible: false,
  };

  public render() {
    const { href } = this.props;
    const { visible } = this.state;

    if (!this.props.isEnabled || this.props.isAuthenticated || !href) {
      return null;
    }

    return (
      <CSSTransition in={visible} timeout={500} classNames="nps-widget-transition">
        <NpsWidgetComponent
          href={href}
          visible
          onChangeVisibility={this.handleChangeVisibility}
          onAccept={trackAccept}
          onDecline={trackDecline}
          className={styles.widget}
        />
      </CSSTransition>
    );
  }

  private handleChangeVisibility = (visible: boolean) => {
    this.setState(
      {
        visible,
      },
      () => {
        if (visible) {
          this.handleShow();
        }
      },
    );
  };

  private handleShow = once(trackShow);
}
